var _defs, _path, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPokeball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "top-curve",
    d: "M 5,50 A 45,45 0 0,1 95,50",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom-curve",
    d: "M 95,50 A 45,45 0 0,1 5,50",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.125 90.104c22.056 0 40-17.944 40-40s-17.944-40-40-40-40 17.944-40 40 17.944 40 40 40zm0-2c-20.645 0-37.485-16.552-37.977-37.081h22.449c.48 8.16 7.25 14.656 15.528 14.656s15.048-6.497 15.528-14.656h22.449C87.61 71.552 70.77 88.104 50.125 88.104zm-13.574-38c0-7.484 6.09-13.574 13.574-13.574s13.574 6.09 13.574 13.574c0 7.485-6.09 13.575-13.574 13.575S36.551 57.59 36.551 50.104zm13.574-38c20.591 0 37.397 16.465 37.973 36.919H65.645c-.559-8.083-7.297-14.493-15.52-14.493s-14.96 6.41-15.52 14.493H12.152c.576-20.453 17.382-36.919 37.973-36.919z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.125 59.725c5.304 0 9.619-4.315 9.619-9.62 0-5.304-4.315-9.619-9.619-9.619s-9.619 4.315-9.619 9.619c0 5.304 4.315 9.62 9.619 9.62zm0-17.24c4.201 0 7.619 3.418 7.619 7.619 0 4.202-3.418 7.62-7.619 7.62s-7.619-3.418-7.619-7.62c0-4.201 3.418-7.619 7.619-7.619z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#ffffff",
    fontWeight: "bold",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#top-curve",
    startOffset: "50%",
    textAnchor: "middle"
  }, "\n      Who's that\n    "))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#ffffff",
    fontWeight: "bold",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#bottom-curve",
    startOffset: "50%",
    textAnchor: "middle"
  }, "\n      Pokemon?\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/pokeball.6a2179e4e949e933c606a70c6b282216.svg";
export { ForwardRef as ReactComponent };